import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuLayoutSelector} from '@Components/contextual-menu/components/contextual-menu-layout-selector';
import {LayoutOptions} from '@Components/contextual-menu/components/contextual-menu-layout-button';
import type {LayoutTypes} from '@PosterWhiteboard/items/layouts/layout.types';
import {MENU_LAYOUTS} from '@PosterWhiteboard/items/menu-item/menu-item.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';

interface MenuLayoutSelectorProps {
  isMobileVersion?: boolean;
}

export function MenuLayoutSelector({isMobileVersion = false}: MenuLayoutSelectorProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const layoutStyle = useGetKeyFromTableItem('layoutStyle');

  if (!activeItem || (activeItem && !('layoutStyle' in activeItem)) || layoutStyle === undefined) {
    throw new Error(`Item doesn't have layoutStyle property`);
  }

  if (!activeItem.isMenu()) {
    return null;
  }

  const onClickHandler = (layout: string): void => {
    activeItem.updateMenuLayout(layout as LayoutTypes);
  };

  return (
    <ContextualMenuLayoutSelector
      isMobileVersion={isMobileVersion}
      layoutFor={LayoutOptions.MENU}
      selectedLayoutId={layoutStyle}
      layoutNames={MENU_LAYOUTS}
      onClick={onClickHandler}
    />
  );
}
